import React, { Fragment } from 'react';
import { elements, colors } from '@peachjar/components';
import { css } from 'react-emotion';

import { PEACHJAR_CONTACT_NUMBER } from '../../../constants';

const { soil, blonde, jungle } = colors;
const { Note } = elements.typography;

const styles = {
  validator: css`
    padding: 1rem;
    border: 1px solid ${soil};
    border-radius: 3px;
    margin-left: -5px;
    margin-top: 2rem;
    background-color: ${blonde};
    display: flex;
    flex-direction: column;
  `,
  marginVertical: css`
    margin-top: 10px;
  `,
  link: css`
    color: ${jungle} !important;

    &:hover {
      color: #71c174 !important;
    }
  `,
};

const NcesErrorMessages = ({
  didEnterCorrectNcesIdLength,
  numSchoolsAssociatedToNcesId,
  numberOfSchoolsInt,
  didExceedAllowedSchoolVariance,
  previousPage,
  eligibility,
  orgNotFound,
  isSoloSchoolInLargerDistrict,
  didEnterSchoolIdInsteadOfDistrictId,
  didEnterDistrictIdInsteadOfSchoolId,
  isCharterSchool,
  isCharterSchoolProceeding,
}) => (
  <Fragment>
    {didEnterCorrectNcesIdLength && (
      <div>
        {eligibility.isEligible === false &&
        eligibility.ineligibilityReason === 'registration-locked' ? (
          <div className={styles.validator}>
            <Note>
              A registration associated with this NCES ID is currently
              in-progress.
            </Note>
            <div className={styles.marginVertical}>
              <Note>Call us at {PEACHJAR_CONTACT_NUMBER} for assistance.</Note>
            </div>
          </div>
        ) : null}
        {eligibility.isEligible === false &&
        eligibility.ineligibilityReason !== 'registration-locked' ? (
          <div className={styles.validator}>
            <Note>
              Note: An account associated with that NCES ID already exists. Did
              you mean to enter that NCES ID?
            </Note>
            <div className={styles.marginVertical}>
              <Note>Call us at {PEACHJAR_CONTACT_NUMBER} for assistance.</Note>
            </div>
          </div>
        ) : null}
        {orgNotFound ? (
          <div className={styles.validator}>
            <Note>We couldnt find a matching NCES ID</Note>
            <div className={styles.marginVertical}>
              <Note>Call us at {PEACHJAR_CONTACT_NUMBER} for assistance.</Note>
            </div>
          </div>
        ) : null}
        {isSoloSchoolInLargerDistrict && !isCharterSchool ? (
          <div className={styles.validator}>
            <Note>
              <b>Note</b>: The NCES database tells us your school is part of a
              district. To start using Peachjar please have your district get in
              touch with us at {PEACHJAR_CONTACT_NUMBER}.
            </Note>
          </div>
        ) : null}
        {isCharterSchool &&
        eligibility.isEligibleAsIndependentSchool === false ? (
          <div className={styles.validator}>
            <Note>
              <b>Note</b>: The NCES database tells us your school is a charter
              school and part of a district. To start using Peachjar please have
              your district get in touch with us at {PEACHJAR_CONTACT_NUMBER}.
            </Note>
            <div className={styles.marginVertical}>
              <Note>Call us at {PEACHJAR_CONTACT_NUMBER} for assistance.</Note>
            </div>
          </div>
        ) : null}
      </div>
    )}

    {didEnterSchoolIdInsteadOfDistrictId ? (
      <div className={styles.validator}>
        <Note>
          <b>Note</b>: You requested {numberOfSchoolsInt} schools but the NCES
          ID you entered is for 1 school. Did you mean to enter that NCES ID?
        </Note>
      </div>
    ) : null}
    {didEnterDistrictIdInsteadOfSchoolId && numberOfSchoolsInt > 1 && (
      <div className={styles.validator}>
        <Note>
          <b>Note</b>: You requested {numberOfSchoolsInt} school but the NCES ID
          you entered is for a district. Did you mean to enter that NCES ID?
        </Note>
      </div>
    )}
    {didEnterDistrictIdInsteadOfSchoolId && numberOfSchoolsInt === 1 && (
      <div className={styles.validator}>
        <Note>
          <b>Note</b>: You entered your district NCES ID. Please enter your school NCES ID instead.
        </Note>
      </div>
    )}
  </Fragment>
);

export default NcesErrorMessages;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/components/NcesErrorMessages.jsx